
class ProductCardForm extends HTMLElement {
  parent; inputs; loading; loader; product; variant; variantId; inputId;

  constructor(){
    super();
    this.loading = false;
    this.loader = this.querySelector('loader');
    this.inputId = this.querySelector('input[name="id"]');
    this.variantId = this.dataset.variantId;
    this.findInputs();
  }

  findInputs = () => {
    this.inputs = this.querySelectorAll('input[type="radio"]');
    this.inputs.forEach(input => {
      input.removeEventListener('change', this.handleChange);
      input.addEventListener('change', this.handleChange);
    });
  };

  handleChange = () => {
    this.loadingState(true);
    if(this.product == undefined)
      this.getProduct(this.changeId);
    else
      this.changeId();
  }

  changeId = () => {
    const selectedRadios = this.querySelectorAll('input[type="radio"]:checked');
    const selectedOptions = [];
    selectedRadios.forEach((radio) => {
      selectedOptions.push(radio.value);
    });
    this.variant = this.product.variants.filter((v) => {
      if(v.options.length == 1){
        return selectedOptions[0].localeCompare(v.option1) == 0;
      } else if(v.options.length == 2){
        return selectedOptions[0].localeCompare(v.option1) == 0 && selectedOptions[1].localeCompare(v.option2) == 0;
      } else if(v.options.length == 3){
        return selectedOptions[0].localeCompare(v.option1) == 0 && selectedOptions[1].localeCompare(v.option2) == 0 && selectedOptions[2].localeCompare(v.option3) == 0;
      }
    })[0];
    this.variantId = this.variant.id;
    this.inputId.value = this.variantId;
    this.checkAvailability();
    this.loadingState(false);
  }

  checkAvailability = () => {
    this.product.options.forEach((option, p) => {
      option.values.forEach((value) => {
        var av = 0;
        if(option.position == 1){
          av = this.product.variants.filter((v) => {
            return value.localeCompare(v.option1) == 0 && v.available;
          }).length;
        } else if(option.position == 2){
          av = this.product.variants.filter((v) => {
            return this.variant.option1.localeCompare(v.option1) == 0 && value.localeCompare(v.option2) == 0 && v.available;
          }).length;
        } else if(option.position == 3){
          av = this.product.variants.filter((v) => {
            return this.variant.option1.localeCompare(v.option1) == 0 && this.variant.option2.localeCompare(v.option2) == 0 && value.localeCompare(v.option3) == 0 && v.available;
          }).length;
        }
        const selector = 'input[name="option-'+p+'"][value="'+value+'"]';
        this.querySelector(selector).disabled = av <= 0;
      });
    });
  }

  getProduct = (callback) => {
    axios.get(window.Shopify.routes.root + 'products/' + this.dataset.productHandle + '.js')
    .then((response) => {
      this.product = response.data;
      this.getVariant();
      console.log(callback);
      if(callback != undefined)
        callback();
    })
    .catch((error) => {
      console.log(error);
      this.loadingState(false);
    });
  }

  loadingState = (loading) => {
    this.loading = loading;
    if(this.loading){
      this.loader.classList.remove('d-none');
    } else {
      this.loader.classList.add('d-none');
    }
  }

  getVariant = () => {
    this.variant = this.product.variants.filter((v) => {
      return v.id == this.variantId;
    })[0];
  }
}

class SwiperElement extends HTMLElement {
  swiper; options;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.options = {};
    if(this.dataset.breakpoints != undefined){
      this.options.breakpoints = {};
      const points = this.dataset.breakpoints.split(';');
      points.forEach((point) => {
        const bp = point.split(':');
        this.options.breakpoints[bp[0]] = {
          slidesPerView: bp[1]
        }
      });
    }
    if(this.dataset.direction != undefined){
      this.options.direction = this.dataset.direction;
    }
    if(this.dataset.navigation != undefined){
      this.options.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if(this.dataset.autoplay != undefined){
      this.options.autoplay = {
        delay: parseInt(this.dataset.autoplay) <= 0 ? 2500 : parseInt(this.dataset.autoplay),
        disableOnInteraction: false
      };
    }
    if(this.dataset.touch == 'false'){
      this.options.allowTouchMove = false;
    }
    if(this.dataset.autowidth != undefined){
      this.slidesPerView = 'auto';
    }
    this.swiper = new Swiper(this, this.options);
  }

  swipeTo = (index) => {
    this.swiper.slideTo(index);
  }
}

class ModalMS extends HTMLElement {
  swiper;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.swiper = this.querySelector('swiper-element');
    this.querySelectorAll('[data-modal-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });
  }

  open = (index) => {
    if(index != undefined)
      this.swipeTo(index);
    this.classList.add('open');
  } 
  close = () => {
    this.classList.remove('open');
  }
  swipeTo = (index) => {
    if(this.swiper != undefined)
      this.swiper.swipeTo(index);
  }
}

class CartReceipt extends HTMLElement {
  select; input; type;

  static RECEIPT = 'ricevuta';
  static INVOICE = 'fattura';

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.select = this.querySelector('select');
    this.input = this.querySelector('input');
    this.type = this.select.value; 
    console.log(this.type);

    this.select.addEventListener('change', this.changeType);
  }

  changeType = () => {
    this.type = this.select.value;
    this.setInput();
  }

  setInput = () => {
    if(this.type == CartReceipt.INVOICE){
      this.input.placeholder = this.dataset.invoicePlaceholder;
      this.input.name = `attributes[${this.dataset.invoiceName}]`;
    } else {
      this.input.placeholder = this.dataset.receiptPlaceholder;
      this.input.name = `attributes[${this.dataset.receiptName}]`;
    }
  }
}

if (!window.customElements.get("product-card-option")) {
  window.customElements.define("product-card-option", ProductCardForm);
}
if (!window.customElements.get("swiper-element")) {
  window.customElements.define("swiper-element", SwiperElement);
}
if (!window.customElements.get("modal-ms")) {
  window.customElements.define("modal-ms", ModalMS);
}
if (!window.customElements.get("cart-receipt")) {
  window.customElements.define("cart-receipt", CartReceipt);
}